/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Toast_Already_RecordedInputs */

const vi_reconcile_toast_already_recorded = /** @type {(inputs: Reconcile_Toast_Already_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoản CK này đã được ghi nhận trước đó — không tạo thanh toán mới`)
};

/**

* @param {Reconcile_Toast_Already_RecordedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_toast_already_recorded = /** @type {((inputs?: Reconcile_Toast_Already_RecordedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Toast_Already_RecordedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_toast_already_recorded(inputs)
});